export * from "./GetBannerClasses";